import apis from '@/apis/index'
import {MessageBox, Toast, Indicator, Popup} from 'mint-ui'
import cloudApi from '@/apis/cloudStorageApi'

let prompt = (_this, title) => {
  if (title === '个人文件') {
    MessageBox.prompt('新建文件夹', '', {
      inputValue: '新建文件夹',
      showInput: true,
      inputPattern: /^.{1,50}$/,
      inputErrorMessage: '名字长度为1-50个字符'
    }).then(({value, action}) => {
      if (action === 'confirm' && value !== null) {
        apis.request(cloudApi.mKdir, {dirName: value, pid: _this.pid}).then(function (response) {
          _this.parentId.push({pid: _this.pid, index: _this.index})
          _this.pid = response.data.id
          _this.index = value
          _this.indexs = value
          window.localStorage.setItem('index', response.data.fileName)
          window.localStorage.setItem('pid', response.data.id)
          let parentArr = JSON.stringify(_this.parentId)
          window.localStorage.setItem('parentId', parentArr)
          _this.$store.commit('changeId', response.data.id)
          apis.request(cloudApi.searchFile, {fileId: response.data.id, page: 0, size: 20}).then(res => {
            let data = res.data.content
            _this.hello = []
            Toast({
              message: '新建成功',
              iconClass: 'icon-success'
            })
          })
        }).catch(function (error) {
          Toast({
            message: error.response.data.message,
            iconClass: 'icon-error'
          })
        })
      }
    })
  } else if (title === '共享文件') {
    MessageBox.prompt('新建文件夹', '', {
      showInput: true,
      inputValue: '新建文件夹',
      inputPattern: /^.{1,50}$/,
      inputErrorMessage: '名字长度为1-50个字符'
    }).then(({value, action}) => {
      if (action === 'confirm' && value !== null) {
        const api = _this.sharePid === '' ? cloudApi.mkFirstShareDr : cloudApi.mKDir
        apis.request(api, {dirName: value, pid: _this.sharePid}).then(function (response) {
          // _this.hello.unshift(response.data)
          _this.shareParentId.push({pid: _this.sharePid, index: _this.shareIndex, LvType: _this.LvType})
          _this.sharePid = response.data.id
          _this.index = response.data.fileName
          _this.shareIndex = response.data.fileName
          window.localStorage.setItem('shareIndex', response.data.fileName)
          window.localStorage.setItem('sharePid', response.data.id)
          let parentArr = JSON.stringify(_this.shareParentId)
          window.localStorage.setItem('shareParentId', parentArr)
          _this.$store.commit('changeId', response.data.id)
          apis.request(_this.message, {fileId: response.data.id, page: 0, size: 20}).then(response => {
            let data = response.data.content
            _this.hello = data
            Toast({
              message: '新建成功',
              iconClass: 'icon-success'
            })
          })
        }).catch(function (error) {
          Toast({
            message: error.response.data.message,
            iconClass: 'icon-error'
          })
        })
      }
    })
  }
}

let rename = (_this) => {
  MessageBox.prompt('重命名', '', {
    showInput: true,
    inputValue: _this.fileName,
    inputPattern: /^.{1,50}$/,
    inputErrorMessage: '名字长度为1-50个字符'
  }).then(({value, action}) => {
    if (action === 'confirm' && value !== null) {
      apis.request(cloudApi.rename, {name: value, fileId: _this.fileId}).then(function (response) {
        _this.hello[_this.indexing].fileName = value
        Toast({
          message: '重命名成功',
          iconClass: 'icon-success'
        })
      }).catch(function (error) {
        Toast({
          message: error.response.data.message,
          iconClass: 'icon-error'
        })
      })
    }
  })
}

let del = (_this, type) => {
  apis.request(cloudApi.removeFiles, {fileIds: _this.fileId}).then(function (response) {
    for (let i = 0; i < _this.delArr.length; i++) {
      _this.hello.removeByValue(_this.delArr[i])
    }
    Toast({
      message: '删除成功',
      iconClass: 'icon-success'
    })
    _this.restore()
    if (type === 1) {
      _this.index = window.localStorage.getItem('index')
      _this.indexs = _this.index
    } else {
      _this.shareIndex = window.localStorage.getItem('shareIndex')
    }
    if (_this.hello.length <= 0) {
      apis.request(_this.message, {fileId: _this.pid, page: _this.page, size: _this.size}).then(response => {
        let data = response.data.content
        if (data.length > 0) {
          for (let i = 0; i < data.length; i++) {
            _this.hello.push(data[i])
          }
        }
        return false
      }).catch(function (error) {
      })
    }
  }).catch(function (error) {
    Toast({
      message: error.response.data.message,
      iconClass: 'icon-error'
    })
  })
}

let collect = (_this) => {
  if (_this.isFavorite === 1) {
    Toast({
      message: '请勿重复收藏',
      iconClass: 'icon-error'
    })
    return false
  }
  apis.request(cloudApi.addFavorite, {fileIds: _this.fileId}).then(function (res) {
    Toast({
      message: '收藏成功',
      iconClass: 'icon-success'
    })
  }).catch(function (error) {
    Toast({
      message: error.response.data.message,
      iconClass: 'icon-error'
    })
  })
}

let delActions = (_this, type) => {
  if (!_this.fs) {
    let checkbox = _this.$refs.mybox
    let arr = ''
    for (let i = 0; i < checkbox.length; i++) {
      if (checkbox[i].className.indexOf('checked') !== -1) {
        arr += checkbox[i].getAttribute('fileId') + ','
      }
    }
    arr = arr.substring(0, arr.length - 1)
    _this.delArr = arr.split(',')
    _this.copyfileId = _this.delArr
    _this.fileId = arr
  } else {
    let checkbox = _this.$refs.hbox
    let arr = ''
    for (let i = 0; i < checkbox.length; i++) {
      if (checkbox[i].className.indexOf('checked') !== -1) {
        arr += checkbox[i].getAttribute('fileId') + ','
      }
    }
    arr = arr.substring(0, arr.length - 1)
    _this.delArr = arr.split(',')
    _this.copyfileId = _this.delArr
    _this.fileId = arr
  }
  if (type === '删除') {
    _this.fileId !== '' ? _this.delVisible = true : _this.delVisible = false
  } else if (type === '分享') {
    _this.fileId !== '' ? _this.currentValue = true : _this.currentValue = false
  } else if (type === '移动到') {
    if (_this.fileId !== '') {
      _this.moveFile()
    }
  } else if (type === '复制到') {
    if (_this.fileId !== '') {
      _this.copy()
    }
  } else if (type === '下载') {
    if (_this.fileId !== '') {
      _this.downLoad('1', _this.fileId, '0', _this.name)
    }
  }
}

export default {prompt, rename, del, collect, delActions}



// WEBPACK FOOTER //
// ./src/components/methods.js